import { defineComponent } from 'vue'
import styles from './styles.module.scss'
import { useComponentStore } from '@/pages/chargermap/nsh5/localStores/component'

/**
 * 戳点渲染功能模块
 */
export default defineComponent({
  name: 'share-icon-view',
  emits: ['handleShare'],

  setup: (props, { emit }) => {
    const componentStore = useComponentStore()
    const handleShare = () => {
      componentStore.bus.emit('openSharePoster')
      emit('handleShare')
    }
    return () =>
      window.client === 'mobile' && (
        <div class={['icon', 'square', styles.shareIcon]} onClick={handleShare}>
          <ns-icon
            name={(process.config as any).icon.share}
            size={window.client === 'mobile' ? '20px' : '24px'}
          />
        </div>
      )
  },
})
